// @flow


/**
 * http://stackoverflow.com/questions/1436438/how-do-you-set-clear-and-toggle-a-single-bit-in-javascript
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Bitwise_Operators
 */
export default class BitUtils {

  static isSet(mask: number, flag: number): boolean {
    return (flag & mask) !== 0;
  }

  static set(mask: number, flag: number): number {
    return flag | mask;
  }

  static toggle(mask: number, flag: number): number {
    return flag ^ mask;
  }

  static remove(mask: number, flag: number): number {
    return flag & ~mask;
  }

}
